// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-options{display:flex;flex-direction:column;padding-bottom:.75rem}@media (min-width:48em){.dropdown-options{padding-bottom:0}}.dropdown-options.is-expanded .icon-chevron-down{transform:rotate(180deg)}.dropdown-options .label{display:inline-block;font-size:1rem;padding-bottom:.25rem}.dropdown-options .button{border-radius:.25rem;font-weight:400;padding-left:.75rem;padding-right:.75rem;width:100%}.dropdown-options .dropdown-container{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
